export default __webpack_public_path__ + "static/media/marco.fc3d127c.jpeg";